import { Component, AfterViewInit, HostListener, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ThemeService } from './service/theme-service.service';
import { rootService } from './service/rootService.service';
import { PerfilWeb } from './cotizador-module/cotizador/automotor/interface/perfil_web';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'Coverit';
  uuid: any = '';

  token: string = '';
  perfil: PerfilWeb | undefined;
  phoneNumber: string = '5491155555555'; // Número de celular predeterminado
  isMobile: boolean = false;
  isLoading: boolean = true;
  private tokenCheckInterval: any;

  constructor(private themeService: ThemeService,
              private rootService: rootService,
              private router: ActivatedRoute,
              private ruta: Router,
              private location: Location
  ) {}

  ngOnInit(): void {
    // Guardar uuid en localStorage solo si está en la URL
    const uuidFromUrl = this.router.snapshot.paramMap.get('uuid');
    if (uuidFromUrl) {
      localStorage.setItem('uuid', uuidFromUrl);
      this.uuid = uuidFromUrl;
    } else {
      this.uuid = localStorage.getItem('uuid');
    }
    this.isLoading = true;
    this.tokenCheckInterval = setInterval(() => {
      const token = localStorage.getItem('token') || '';
      const uuid = localStorage.getItem('uuid');
      if (uuid && token) {
        clearInterval(this.tokenCheckInterval);
        this.themeService.obtenerPerfil(token).subscribe({
          next: () => {},
          error: (err) => {
            console.error('Error al obtener perfil:', err);
            this.isLoading = false;
            alert('No se pudo cargar el perfil.');
          }
        });
      } else if (!uuid) {
        clearInterval(this.tokenCheckInterval);
        this.isLoading = false;
        alert('El enlace está mal formado. Por favor, verifique e intente nuevamente.');
      }
    }, 100);
    this.themeService.perfil$.subscribe((perfil) => {
      this.perfil = perfil === null ? undefined : perfil;
      this.phoneNumber = perfil?.pas_whatsapp?.trim() || '5491155555555';
      this.isLoading = false;
    });
    this.rootService.getToken('crmartinar@yahoo.com.ar', 'prueba12345#')
                    .subscribe(
                      (datos) => {
                        this.token = datos.access_token;
                        localStorage.setItem('token', this.token);
                      });
    this.isMobile = window.innerWidth < 900;
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth < 900;
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.sendHeight();
    this.isMobile = window.innerWidth < 900;
  }

  ngAfterViewInit() {
    setTimeout(() => this.sendHeight(), 100); // Asegurar que se renderice bien
  }

  private sendHeight() {
    const height = document.documentElement.scrollHeight;
    window.parent.postMessage({ type: 'iframeHeight', height }, '*');
  }
  }
